export default [
  { id: "#rect1", x: "0.4", y: "-3.1", width: "195.5", height: "195.5" },

  { id: "#rect2", x: "0.4", y: "293.5", width: "195.5", height: "195.5" },

  { id: "#rect3", x: "0.4", y: "590.2", width: "195.5", height: "195.5" },

  { id: "#rect4", x: "0.4", y: "886.9", width: "195.5", height: "195.5" },

  { id: "#rect5", x: "298.4", y: "-3.1", width: "195.5", height: "195.5" },

  { id: "#rect6", x: "298.4", y: "293.5", width: "195.5", height: "195.5" },

  { id: "#rect7", x: "298.4", y: "590.2", width: "195.5", height: "195.5" },

  { id: "#rect8", x: "298.4", y: "886.9", width: "195.5", height: "195.5" },

  { id: "#rect9", x: "596.4", y: "-3.1", width: "195.5", height: "195.5" },

  { id: "#rect10", x: "596.4", y: "293.5", width: "195.5", height: "195.5" },

  { id: "#rect11", x: "596.4", y: "590.2", width: "195.5", height: "195.5" },

  { id: "#rect12", x: "596.4", y: "886.9", width: "195.5", height: "195.5" },

  { id: "#rect13", x: "884.9", y: "-3.1", width: "195.5", height: "195.5" },

  { id: "#rect14", x: "884.9", y: "293.5", width: "195.5", height: "195.5" },

  { id: "#rect15", x: "884.9", y: "590.2", width: "195.5", height: "195.5" },

  { id: "#rect16", x: "884.9", y: "886.9", width: "195.5", height: "195.5" }
];
